import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCartPlus } from "@fortawesome/free-solid-svg-icons";
import styles from "./BetSummarySidebar.module.css";
import { formatCurrency, formatShortDate } from "../../../../services/api";
import {
  isLotteryExtra,
  getExtraDrawDate,
  isLotteryBettingClosed,
  getClosingScheduleSummary,
  getDrawDateLabel,
} from "../lotteryHelpers";

/**
 * Columna derecha (paso 3): resumen de la apuesta + total + CTA "Añadir al carrito".
 * Solo presentación: la validación y el alta al carrito viven en ApuestasPage.
 */
const BetSummarySidebar = ({
  lottery,
  numero = ["", "", "", ""],
  series = "",
  cantidad = 1,
  maxFracciones = 1,
  total = 0,
  now,
  canAdd = false,
  hint = "",
  error = "",
  onAddToCart,
  onBack,
}) => {
  const closed = lottery ? isLotteryBettingClosed(lottery, now) : false;
  const extra = lottery ? isLotteryExtra(lottery) : false;
  const extraDate = lottery ? getExtraDrawDate(lottery) : null;
  const drawLabel = lottery ? getDrawDateLabel(lottery) : null;
  const numberComplete = numero.every((d) => d !== "");

  return (
    <aside className={styles.sidebar} aria-labelledby="bet-summary-title">
      <p className={styles.step}>Paso 3</p>
      <h2 id="bet-summary-title" className={styles.title}>
        Resumen
      </h2>

      {!lottery ? (
        <p className={styles.empty}>
          Selecciona una lotería para ver aquí tu número, serie, fracciones y el
          total a pagar.
        </p>
      ) : (
        <dl className={styles.rows}>
          <div className={styles.row}>
            <dt className={styles.label}>Lotería</dt>
            <dd className={styles.value}>{lottery.name}</dd>
          </div>
          <div className={styles.row}>
            <dt className={styles.label}>Sorteo</dt>
            <dd className={styles.value}>
              {lottery.sorteo != null ? `#${lottery.sorteo}` : "—"}
              {drawLabel ? (
                <span className={styles.subValue}>{drawLabel}</span>
              ) : null}
              {extra && extraDate && !drawLabel ? (
                <span className={styles.subValue}>
                  {formatShortDate(extraDate)}
                </span>
              ) : null}
            </dd>
          </div>
          <div className={`${styles.row} ${styles.rowNumber}`}>
            <dt className={styles.label}>Número</dt>
            <dd className={styles.numberValue} aria-live="polite">
              {numero.map((d, i) => (
                <span
                  key={i}
                  className={`${styles.numberDigit} ${
                    d === "" ? styles.numberDigitEmpty : ""
                  }`}
                >
                  {d === "" ? "–" : d}
                </span>
              ))}
              <span className={styles.srOnly}>
                {numberComplete ? numero.join("") : "sin completar"}
              </span>
            </dd>
          </div>
          <div className={styles.row}>
            <dt className={styles.label}>Serie</dt>
            <dd className={`${styles.value} ${!series ? styles.muted : ""}`}>
              {series || "Sin elegir"}
            </dd>
          </div>
          <div className={styles.row}>
            <dt className={styles.label}>Fracciones</dt>
            <dd className={styles.value}>
              {cantidad} de {maxFracciones}
            </dd>
          </div>
          <div className={styles.row}>
            <dt className={styles.label}>Costo fracciones</dt>
            <dd className={styles.value}>{formatCurrency(total)}</dd>
          </div>
        </dl>
      )}

      <div className={styles.totalBlock}>
        <span className={styles.totalLabel}>Total</span>
        <span className={styles.totalValue}>
          {formatCurrency(lottery ? total : 0)}
        </span>
      </div>

      {lottery && closed ? (
        <p className={styles.closedNotice} role="status">
          {getClosingScheduleSummary(lottery)}
        </p>
      ) : null}

      {error ? (
        <div className={styles.error} role="alert">
          {error}
        </div>
      ) : null}

      <button
        type="button"
        className={styles.cta}
        onClick={onAddToCart}
        disabled={!canAdd}
      >
        <FontAwesomeIcon icon={faCartPlus} />
        Añadir al carrito
      </button>
      {hint ? <p className={styles.hint}>{hint}</p> : null}

      <button type="button" className={styles.back} onClick={onBack}>
        <FontAwesomeIcon icon={faArrowLeft} />
        Volver
      </button>
    </aside>
  );
};

export default BetSummarySidebar;
